import React, { useState } from 'react';
//
import Md2React from '../../../Markdown2React';
//
import { webInfoText } from '../../config';
//
import './InfoTool.scss';

//
const InfoTool = () => {
	const [test, setTest] = useState(null);
	//
	return (
		<div>
			<Md2React.Normal content={webInfoText} />
		</div>
	);
};

export default InfoTool;
